// extracted by mini-css-extract-plugin
export default {"controlGrid":"AddOrEditBanner_controlGrid__P7gdV","instructions":"AddOrEditBanner_instructions__x6fYS","icon":"AddOrEditBanner_icon__+Duj9"};